import { useNavigate, useParams } from 'react-router-dom';

import { SheetType, useTaskOverlayState } from 'views/tasks/task-state';
import DeleteTaskDialog from 'views/tasks/widgets/DeleteTaskDialog';
import TaskViewDetailsSheet from 'views/tasks/widgets/TaskViewDetailsSheet';

const TaskOverlays = () => {
    const { taskOverlayState, closeAllOverlays, openDeleteTaskDialog, closeDeleteTaskDialog } = useTaskOverlayState();
    const navigate = useNavigate();
    const { taskGUID } = useParams<{ taskGUID: string }>();

    const handleClose = () => {
        closeAllOverlays();
        if (taskGUID) {
            navigate('/tasks', { replace: true });
        }
    };

    return (
        <>
            {taskOverlayState.deleteTaskGuid && (
                <DeleteTaskDialog
                    open
                    taskGuid={taskOverlayState.deleteTaskGuid}
                    onOpenChange={handleClose}
                    onCancel={() => closeDeleteTaskDialog()}
                />
            )}
            {taskOverlayState.sheetType === SheetType.VIEW && taskOverlayState.taskGuid && (
                <TaskViewDetailsSheet
                    open
                    taskGuid={taskOverlayState.taskGuid}
                    onOpenDeleteDialog={() => openDeleteTaskDialog(taskOverlayState.taskGuid as string)}
                    onOpenChange={handleClose}
                />
            )}
        </>
    );
};

export default TaskOverlays;
